import ButtonLoader from '../Button'
import { useGeoRuntime } from '../../geo/useGeoRuntime'

type RegisterButtonProps = {
  handleSubmit: () => void
  disabled: boolean
}

const RegisterButton = ({ handleSubmit, disabled }: RegisterButtonProps) => {
  const { getCopyKey } = useGeoRuntime()

  return (
    <ButtonLoader
      onClick={handleSubmit}
      disabled={disabled}
      className="ejForm__button button button--yellow"
    >
      <span data-i18n={getCopyKey('hero.button')}>Регистрация</span>
    </ButtonLoader>
  )
}

export default RegisterButton
